import { State } from './types';

export const DEFAULT_STATE: State = [];
